import { render } from "./roadMapComponent.vue?vue&type=template&id=6f79b708"
import script from "./roadMapComponent.vue?vue&type=script&lang=js"
export * from "./roadMapComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__